import { m } from "framer-motion";
import Image from "next/image";
import { Props } from "./types";

const ARROW_RIGHT_PATH = `M4.22768 12.3759L4.22795 12.376C4.85842 12.4626 5.48704 12.559 6.11295 12.6599C6.25927 12.6834 6.40421 12.7071 6.54824 12.7306C6.99124 12.8031 7.42553 12.8741 7.86416 12.9319C8.52296 13.0186 9.1832 13.0993 9.8449 13.1773L4.22768 12.3759ZM4.22768 12.3759C4.22592 12.3757 4.21158 12.373 4.19505 12.3494C4.17753 12.3245 4.17494 12.2998 4.17697 12.2875L3.68367 12.2059L4.1768 12.2885C4.18
        12.2694 4.18905 12.2549 4.20614 12.2429C4.22505 12.2297 4.25282 12.2212 4.28481 12.2254L4.35079 11.7298L4.28331 12.2252C4.82642 12.2992 5.36832 12.3827 5.91488 12.4679C6.09488 12.4963 6.27987 12.5268 6.46698 12.5577C6.76859 12.6075 7.07569 12.6582 7.37619 12.702L7.3764 12.702C8.47865 12.8623 9.5829 12.9904 10.6807 13.1153C10.6951 13.1169 10.709 13.1185 10.7225 13.1201C10.7296
        13.1241 10.7354 13.1271 10.7396 13.1293C10.785 13.1527 10.8239 13.1636 10.8336 13.1663L10.8341 13.1665C10.8497 13.1708 10.8623 13.1736 10.8692 13.175C10.8833 13.1779 10.895 13.1798 10.9006 13.1806C10.9486 13.1878 11.0949 13.2004 11.3886 13.2249C11.5557 13.2388 11.7244 13.2536 11.8943 13.2684C12.342 13.3076 12.7978 13.3475 13.251 13.375C14.5251 13.4525 15.6161 13.4884 16.5668 13.4923C14.767
        13.5465 13.1053 13.5153 11.6116 13.3735L11.6115 13.3735M4.22768 12.3759L11.6115 13.3735M11.6115 13.3735C11.0907 13.3241 10.5697 13.2627 10.0431 13.2007M11.6115 13.3735L10.0431 13.2007M22.813 12.3263C22.8484 12.3321 22.884 12.3377 22.9195 12.3434L22.813 12.3263ZM22.813 12.3263C22.8508 12.3172 22.8887 12.308 22.9266 12.2988L22.813 12.3263ZM23.9186 11.4692C23.8921 11.4659 23.8657 11.4626 23.8394 11.4593C23.578 11.4267 23.3264 11.3954 23.0761
        11.3557L23.0761 11.3557C22.772 11.3075 22.4684 11.2544 22.1612 11.2004L22.1607 11.2003C21.6088 11.1038 21.0587 10.989 20.5006 10.8715L20.5003 10.8714C19.9452 10.7549 19.3985 10.6329 18.8602 10.4886L18.8598 10.4885C18.2372 10.3221 17.6183 10.1405 16.9977 9.95046L16.994 9.96244C16.953 9.95559 16.9129 9.95032 16.8728 9.94613C16.8694 9.94369 16.8656 9.94067 16.862 9.93728C16.8597 9.93517 16.8579 9.93328 16.8566 9.93177C16.8554 9.93049 16.8548
        9.92971 16.8547 9.92957C16.8547 9.92954 16.8547 9.92954 16.8547 9.92955L23.9186 11.4692ZM23.9186 11.4692C24.0015 11.4793 24.0884 11.486 24.1844 11.4924L24.2854 12.473C24.121 12.5188 23.9497 12.5657 23.7754 12.6074C23.37 12.706 22.9642 12.8044 22.5581 12.9021L22.5444 12.9054L22.5444 12.9052C21.9438 13.0317 21.3272 13.1534 20.6168 13.2528C22.2514 13.0609 22.9201 12.9659 24.022 12.6994C24.0854 12.6839 24.1487 12.6664 24.2208 12.6464C24.2274 12.6446 24.2341 12.6427
        24.2409 12.6408L24.6379 13.5476C24.4576 13.6594 24.2784 13.7731 24.0999 13.8888C23.6309 14.1934 23.1754 14.5345 22.7224 14.8887C22.2506 15.2583 21.7907 15.6284 21.3561 16.02L21.3559 16.0203C20.9565 16.3796 20.5689 16.7473 20.1958 17.1289L20.1956 17.129C20.1527 17.1729 20.1099 17.2165 20.0672 17.2601C19.7315 17.6026 19.4044 17.9363 19.093 18.2835C19.0926 18.2859 19.0922 18.2894 19.0921 18.294C19.0921 18.303 19.0935 18.3126 19.0961 18.3212C19.0974 18.3252
        19.0988 18.3284 19.0999 18.3307C19.1007 18.3324 19.1013 18.3333 19.1016 18.3337C19.1038 18.3365 19.1125 18.3452 19.1305 18.3505C19.1478 18.3556 19.159 18.3532 19.1613 18.3526C19.4073 18.1594 19.623 17.934 19.8656 17.6805C19.9169 17.6268 19.9694 17.5719 20.0237 17.5158L20.0242 17.5153C20.2383 17.2946 20.4537 17.0749 20.6705 16.8566L23.9186 11.4692ZM25.0936 13.9855C25.1558 13.9471 25.2177 13.9083 25.2796 13.8694C25.4373 13.7704 25.595 13.6714 25.7572 13.5798C25.8472
        13.5291 25.9372 13.4783 26.0272 13.4274C26.1713 13.346 26.3155 13.2645 26.46 13.1835C26.4952 13.1655 26.5304 13.1474 26.5656 13.1293C27.0081 12.902 27.4506 12.6748 27.8958 12.453M25.0936 13.9855L24.8309 13.5601M25.0936 13.9855L24.8309 13.5602C24.8309 13.5601 24.8309 13.5601 24.8309 13.5601M25.0936 13.9855C24.6459 14.262 24.2185 14.5664 23.7925 14.8743C23.3764 15.1758 22.9704 15.4969 22.575 15.8253C22.5555 15.8415 22.536 15.8577 22.5165 15.874C22.1304 16.195 21.7423
        16.5176 21.3793 16.8643C21.2955 16.9451 21.2118 17.0255 21.1278 17.1059L20.7801 16.7469C20.7751 16.7515 20.7701 16.7563 20.765 16.761C20.7329 16.7918 20.7007 16.8225 20.6684 16.8534L24.8309 13.5601M24.8309 13.5601C24.8866 13.5257 24.9445 13.4894 25.0041 13.452C25.1651 13.3509 25.3383 13.2422 25.5113 13.1445L25.5118 13.1442C25.6004 13.0943 25.6899 13.0437 25.7798 12.9929C25.9247 12.911 26.0706 12.8286 26.2157 12.7473L26.2236 12.7429L26.2317 12.7387C26.267
        12.7206 26.3023 12.7025 26.3376 12.6843C26.7791 12.4576 27.2237 12.2293 27.6712 12.0063M27.6712 12.0063C27.6708 12.0065 27.6705 12.0067 27.6701 12.0069L27.8958 12.453M27.6712 12.0063C27.6717 12.006 27.6723 12.0058 27.6728 12.0055L27.8958 12.453M27.6712 12.0063C27.7191 11.982 27.7363 11.9685 27.7419 11.9636C27.7422 11.9633 27.7424 11.9631 27.7426 11.9629M27.8958 12.453C28.0306 12.3848 28.1365 12.3074 28.2001 12.1649C28.2594 12.033 28.2634 11.8807 28.2121
        11.7461C28.2001 11.7147 28.1849 11.6855 28.1676 11.657C28.1758 11.6121 28.1799 11.5668 28.1756 11.5206M27.7426 11.9629C27.7423 11.9635 27.7422 11.9638 27.7421 11.9639C27.742 11.9641 27.7422 11.9638 27.7426 11.9631C27.7435 11.9619 27.7438 11.9618 27.7426 11.9629ZM27.7426 11.9629C27.7429 11.9625 27.7432 11.9618 27.7435 11.961L27.7441 11.9598C27.7484 11.9503 27.7491 11.9365 27.7453 11.9254M27.7453 11.9254C27.7455 11.9258 27.7456 11.9261 27.7456 11.9261C27.7456
        11.9261 27.7453 11.9254 27.7448 11.9242C27.745 11.9246 27.7451 11.925 27.7453 11.9254ZM27.7453 11.9254C27.7446 11.9241 27.743 11.921 27.7398 11.9158L27.6419 11.7539L27.6756 11.5678C27.6757 11.5673 27.6758 11.5669 27.6759 11.5664M27.6759 11.5664L27.6775 11.567C27.6777 11.5675 27.6778 11.5679 27.6779 11.5682C27.6779 11.5685 27.678 11.5687 27.6779 11.5685L27.679 11.5684L27.6808 11.5682L27.6826 11.5689C27.683 11.569 27.6833 11.5691 27.6836 11.5692C27.6864 11.5703
        27.6876 11.5708 27.6876 11.5708C27.6876 11.5708 27.687 11.5705 27.6858 11.5699C27.6856 11.5698 27.6853 11.5696 27.6851 11.5695C27.6844 11.5691 27.6836 11.5687 27.6828 11.5682C27.6828 11.5682 27.6827 11.5681 27.6826 11.5681L27.6829 11.568L28.1756 11.5206M27.6759 11.5664L27.6149 11.5444L27.5569 11.5018C27.5391 11.4887 27.5024 11.477 27.4561 11.4923L27.455 11.4927C27.4248 11.5026 27.4083 11.5081 27.3913 11.5137C27.3745 11.5193 27.357 11.5251 27.3251 11.5356L27.2482
        11.5608L27.1673 11.5605C27.1167 11.5603 27.0661 11.5601 27.0155 11.5599C26.7576 11.5589 26.4982 11.5579 26.2391 11.5557L26.2307 11.5556L26.2222 11.5553C26.1597 11.5526 26.0968 11.55 26.0335 11.5474C25.5589 11.5278 25.0645 11.5075 24.5732 11.4553C23.9693 11.3912 23.3604 11.3118 22.7514 11.1932M27.6759 11.5664L16.8455 9.89253C16.8471 9.88306 16.8514 9.8748 16.8598 9.86702C16.8689 9.85858 16.8828 9.85129 16.9005 9.84922L16.8423 9.35261M28.1756 11.5206L27.6836
        11.5661L27.6801 11.5665M28.1756 11.5206C28.1626 11.3853 28.0941 11.258 27.9882 11.1732C27.9448 11.1379 27.8992 11.1155 27.8528 11.0987L27.6801 11.5665M27.6801 11.5665C27.6793 11.566 27.6785 11.5654 27.6776 11.5648C27.6775 11.5635 27.6775 11.5624 27.6774 11.5614C27.6773 11.5578 27.6774 11.5559 27.6774 11.5559C27.6774 11.5559 27.6773 11.5579 27.6766 11.5625C27.6765 11.5629 27.6764 11.5634 27.6763 11.5639C27.6761 11.5638 27.6759 11.5636 27.6757 11.5635C27.6749 11.5629 27.6741 11.5622 27.6732 11.5616M27.6801 11.5665L27.6762 11.5645C27.6758 11.5638 27.6754 11.5634 27.6753 11.5632L27.6732 11.5616M16.8423 9.35261C17.0529 9.32858 17.2447 9.35953 17.4449 9.41883C17.4614 9.4237 17.4779 9.42856 17.4943 9.43343C17.5661 9.45463 17.638 9.47586 17.7094 9.49744L16.8423 9.35261ZM16.8423 9.35261L16.899 9.84938C17.0215 9.83541 17.1426 9.85077 17.303 9.89825L17.3031 9.8983C17.3199 9.90326 17.3366 9.90819 17.3532 9.91309C17.4249 9.93428 17.4949 9.95497 17.5647 9.97606L17.5655 9.97629C17.7578 10.0341 17.9499 10.0905 18.1406 10.1463L18.1421 10.1468C18.5127 10.254 18.8931 10.3612 19.2785 10.4545C20.4335 10.7356 21.5959 10.9687 22.7514 11.1932M22.7514 11.1932C22.7514 11.1932 22.7513 11.1932 22.7512 11.1932L22.8468 10.7024L22.7514 11.1932ZM27.6732 11.5616C27.6728 11.5613 27.6724 11.5609 27.672 11.5606L27.672 11.5606L27.6732 11.5616ZM10.0431 13.2007C9.97721 13.1929 9.91122 13.1851 9.84512 13.1774L10.0431 13.2007ZM11.075 13.1659C11.075 13.1659 11.0737 13.1657 11.0714 13.1652C11.0739 13.1656 11.0751 13.1659 11.075 13.1659ZM10.9758 13.1841C10.9756 13.184 10.9767 13.184 10.9793 13.1841C10.9772 13.1841 10.9759 13.1841 10.9758 13.1841Z`;

export function CloseIcon({ color }: Props): JSX.Element {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 10C30 10 23.4783 14.3478 19.1304 18.6957C14.7826 23.0435 10 30 10 30"
        stroke={color?.hex || "#000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10C10 10 14.7826 16.087 19.5652 21.3043C24.3478 26.5217 30 30 30 30"
        stroke={color?.hex || "#000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuIcon({ color }: Props): JSX.Element {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 20H35"
        stroke={color?.hex || "#000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10C5 10 17.5 11.5 23.5 11.5C29.5 11.5 35 10 35 10"
        stroke={color?.hex || "#000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 30C5 30 10.5 28.5 16 28.5C21.5 28.5 35 30 35 30"
        stroke={color?.hex || "#000"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowRight({ color }: Props) {
  return (
    <svg
      width="32"
      height="25"
      viewBox="0 0 32 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={ARROW_RIGHT_PATH}
        fill="#D3D3D3"
        stroke={color ? color : "#D3D3D3"}
      />
    </svg>
  );
}

export function Arrow({
  color,
  direction,
  style,
}: {
  color: any[any];
  direction: "left" | "";
  style?: string;
}) {
  if (style == "default") {
    return (
      <svg
        className={direction == "left" ? "scale-x-[-1]" : ""}
        width="79"
        height="76"
        viewBox="0 0 79 76"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.875 37.6754L69.125 37.6754"
          stroke={color?.hex}
          strokeLinecap="round"
        />
        <path
          d="M49.375 56.5127L69.125 37.6752L49.375 18.8378"
          stroke={color?.hex}
          strokeLinecap="round"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="32"
        height="25"
        viewBox="0 0 32 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={direction == "left" ? "scale-x-[-1]" : ""}
      >
        <path
          d={ARROW_RIGHT_PATH}
          fill="#D3D3D3"
          stroke={color ? color : "#D3D3D3"}
        />
      </svg>
    );
  }
}

export function ArrowDown({ color }: Props) {
  return (
    <svg
      width="19"
      height="73"
      viewBox="0 0 19 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5479 0.183157C12.977 0.0623572 12.3575 0.44056 12.2505 1.0269C12.0353 2.20155 11.8016 3.37371 11.559 4.54348C11.3314 5.64617 11.089 6.74669 10.8922 7.85599C10.6718 9.0993 10.4628 10.3447 10.2591 11.5911C10.0778 12.7033 9.89245 13.8179 9.7361 14.9337C9.39843 17.3425 9.09731 19.7559 8.79369 22.1679C8.49166 24.5686 8.26536 26.9799 8.16022 29.3964C8.05771 31.7495 7.97168 34.1052 7.96092 36.4614C7.95484 37.7606 7.95443 39.0589 7.97036 40.3578C7.98339 41.5077 8.02671 42.6561 8.0636 43.8063C8.08467 44.4717 8.13861 45.1369 8.17457 45.8017C8.20359 46.3133 8.24588 46.8243 8.28461 47.336C8.37265 48.4859 8.46361 49.638 8.59344 50.7837C8.86428 53.1644 9.12665 55.5488 9.51533 57.9137C9.8782 60.1224 10.2956 62.3181 10.7241 64.5149C10.7538 64.6648 10.7884 64.8136 10.8226 64.9625C10.6235 64.607 10.4206 64.2533 10.2139 63.9008C9.65708 62.9535 9.03251 62.0379 8.39473 61.1428C7.73275 60.2152 7.05713 59.2937 6.33269 58.4139C5.67707 57.6164 5.00161 56.8373 4.296 56.0828C3.59507 55.3327 2.89755 54.5766 2.16388 53.8578C1.83282 53.5341 1.26943 53.5241 0.896294 53.7728C0.51359 54.0284 0.340266 54.5384 0.482692 54.9688C0.511498 55.0559 0.55327 55.1397 0.608828 55.2179C1.07508 55.8703 1.65201 56.4398 2.2015 57.0208C2.6571 57.5041 3.10995 57.9904 3.55888 58.4796C3.49812 58.4085 3.43526 58.3376 3.37369 58.2673C3.58392 58.508 3.79382 58.7477 4.00536 58.9875C4.66141 59.7389 5.26488 60.5402 5.8677 61.3346C6.45485 62.1094 7.0274 62.9037 7.56198 63.7153C8.10787 64.5464 8.64693 65.3797 9.13154 66.249C9.37036 66.6772 9.6202 67.0995 9.84213 67.537C10.0715 67.9905 10.303 68.4438 10.5317 68.8985C10.9549 69.822 11.379 70.7447 11.7908 71.6731C11.9084 71.9336 12.0458 72.1402 12.3097 72.2724C12.5539 72.3956 12.8412 72.416 13.0999 72.3304C13.1602 72.3104 13.2168 72.2841 13.2721 72.254C13.3562 72.2731 13.4415 72.2848 13.5292 72.2806C13.786 72.2674 14.0321 72.1487 14.2013 71.9557C14.2718 71.8768 14.3179 71.7925 14.3535 71.7062C14.5791 71.426 14.6582 71.0388 14.5536 70.6671C14.5304 70.5841 14.5068 70.5013 14.4835 70.4178C14.5118 69.8349 14.5395 69.2516 14.5706 68.6688C14.6593 67.652 14.7385 66.6307 14.8915 65.6207C15.0615 64.4988 15.2582 63.3843 15.5248 62.2805C16.0463 60.1174 16.5806 57.9586 17.2026 55.8222C17.4055 55.1227 17.6346 54.4291 17.8676 53.7405C17.9891 53.3852 18.111 53.0298 18.2352 52.6746C18.2928 52.511 18.3493 52.346 18.4061 52.1816C18.535 51.8081 18.6097 51.4483 18.582 51.0485C18.5484 50.5815 18.2217 50.1829 17.759 50.0841C17.4873 50.0261 17.1977 50.082 16.966 50.2364C16.7574 50.3756 16.5605 50.6285 16.5272 50.885C16.5102 51.005 16.4886 51.1158 16.4561 51.2329C16.4869 51.1466 16.5174 51.061 16.5482 50.9747C16.1345 52.1379 15.735 53.3034 15.3636 54.4801C15.0378 55.5095 14.7561 56.5513 14.4875 57.5969C14.2187 58.6404 13.9514 59.685 13.7186 60.7377C13.5906 61.3132 13.463 61.8896 13.3445 62.469C13.2348 63.0049 13.145 63.544 13.0531 64.0832C13.0224 64.2661 12.9999 64.451 12.9793 64.6364C12.9067 64.3227 12.8358 64.0089 12.7753 63.6938C12.6231 62.9192 12.4714 62.1444 12.3213 61.3695C11.9204 59.1388 11.5288 56.9088 11.2496 54.6577C10.9472 52.2207 10.6664 49.7839 10.4792 47.3347C10.3011 45.0108 10.184 42.6823 10.1563 40.3514C10.1292 38.0061 10.1261 35.6588 10.1979 33.3137C10.2594 31.3325 10.3389 29.3534 10.4538 27.3739C10.4457 27.4683 10.4385 27.5624 10.4309 27.6567C10.4833 27.0096 10.5364 26.3629 10.5885 25.7165C10.6378 25.1152 10.7136 24.516 10.7763 23.9163C10.8994 22.7522 11.0654 21.5921 11.2148 20.4311C11.5128 18.1094 11.8046 15.7887 12.1732 13.4765C12.5019 11.4123 12.8349 9.34979 13.2277 7.29669C13.4028 6.38407 13.6059 5.47663 13.7915 4.56487C13.9986 3.53909 14.2039 2.51399 14.3913 1.48391C14.4968 0.894324 14.1426 0.310037 13.548 0.182968L13.5479 0.183157Z"
        fill={color ? color : "#D3D3D3"}
      />
    </svg>
  );
}

export function DownloadIcon({ color }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3924 12.5304L12.3525 12.5182C12.2778 12.7619 12.2121 13.0067 12.1489 13.2419L12.3924 12.5304ZM12.3924 12.5304C12.4223 12.7707 12.4524 13.0109 12.4826 13.2511M12.3924 12.5304L12.4826 13.2511M12.4826 13.2511C12.4893 13.3064 12.4967 13.3615 12.5046 13.4167C12.5046 13.4168 12.5046 13.4169 12.5046 13.417C12.5188 13.5159 12.5345 13.6148 12.5506 13.7136M12.4826 13.2511L12.1346 13.2949M12.5506 13.7136L12.0608 13.6133C12.0797 13.521 12.1013 13.4199 12.1287 13.3169L12.1291 13.3156C12.1309 13.3087 12.1328 13.3018 12.1346 13.2949M12.5506 13.7136L13.0441 13.6333C13.04 13.6082 13.036 13.5833 13.032 13.5586L12.979 13.1909L12.9787 13.1887C12.9578 13.0227 12.937 12.8568 12.9163 12.6909C12.9163 12.6909 12.9163 12.6909 12.9163 12.6909C12.9073 12.619 12.8983 12.547 12.8894 12.4751C12.8696 12.5382 12.8499 12.6014 12.8305 12.6647C12.7733 12.8515 12.7214 13.0394 12.6706 13.2275C12.6705 13.2278 12.6704 13.2281 12.6703 13.2284C12.6574 13.2763 12.6445 13.3243 12.6316 13.3723C12.625 13.3967 12.6185 13.4211 12.6119 13.4455C12.5883 13.534 12.569 13.6237 12.5506 13.7136ZM12.1346 13.2949L11.9865 13.3136C11.9865 13.3132 11.9864 13.3129 11.9864 13.3125M12.1346 13.2949L11.9864 13.3125M11.9864 13.3125C12.0064 13.4773 12.032 13.6394 12.0571 13.7939L13.0404 13.8139C13.0583 13.7266 13.0753 13.6486 13.0949 13.5748C13.1014 13.5507 13.1078 13.5267 13.1142 13.5029C13.1781 13.265 13.2394 13.0371 13.3086 12.8111L13.3086 12.8111C13.3929 12.5358 13.4821 12.2613 13.5727 11.9831L13.5729 11.9825C13.7347 11.4837 13.9144 10.9876 14.0981 10.4836L14.0982 10.4833C14.2803 9.98231 14.4667 9.4901 14.6739 9.00724L14.674 9.00691C14.9134 8.4479 15.1674 7.89329 15.4299 7.33748L15.4192 7.33241C15.4308 7.29586 15.4409 7.26 15.4499 7.22421C15.4523 7.2219 15.455 7.21944 15.458 7.21698C15.4639 7.21222 15.4684 7.20935 15.4704 7.20825L15.2266 6.77175M11.9864 13.3125L14.9615 7.11586C14.9646 7.10404 14.9676 7.09209 14.9705 7.07994C14.9984 6.95562 15.1117 6.83589 15.2266 6.77175M11.9864 13.3125C11.9386 12.9328 11.8911 12.5528 11.8443 12.1726L11.843 12.1617L11.8421 12.1506C11.6478 9.6688 11.5936 8.01213 11.9141 5.18212C11.9305 5.03693 11.9463 4.89153 11.9622 4.74614C12.0601 3.84726 12.158 2.94839 12.3982 2.09537L12.8795 2.2309L12.3978 2.09689C12.4 2.08923 12.3997 2.08466 12.3994 2.08278C12.3994 2.08217 12.3993 2.08166 12.3992 2.08124C12.3989 2.08022 12.3986 2.07969 12.3985 2.07949C12.3984 2.07931 12.398 2.07855 12.3963 2.07729C12.3948 2.07618 12.3893 2.0725 12.377 2.06959L12.4919 1.58297L12.3779 2.06981C12.3608 2.0658 12.3261 2.06718 12.2906 2.08612C12.269 2.09767 12.2609 2.10784 12.2588 2.11097C12.1062 2.65113 11.9755 3.26872 11.885 4.09592C11.4465 8.10185 11.4473 10.134 11.8724 13.5529C11.8797 13.6109 11.8891 13.669 11.9 13.7369C11.901 13.7431 11.902 13.7493 11.903 13.7556L10.9635 14.0611C10.8756 13.8879 10.7857 13.7154 10.6938 13.5433C10.4525 13.093 10.1735 12.6517 9.88026 12.2101L11.9864 13.3125ZM15.2266 6.77175C15.3541 6.70061 15.5078 6.67841 15.6475 6.71134M15.2266 6.77175L15.4702 7.20837C15.4912 7.19666 15.5174 7.19437 15.5328 7.19801M15.6475 6.71134L15.5327 7.19797C15.5327 7.19798 15.5328 7.19799 15.5328 7.19801M15.6475 6.71134C15.8854 6.7675 16.0399 6.96722 16.0383 7.19514L15.6475 6.71134ZM15.5328 7.19801C15.535 7.19853 15.5368 7.19908 15.5382 7.19959C15.5357 7.29689 15.5091 7.39694 15.4457 7.53448L15.4456 7.53463C15.4387 7.54981 15.4317 7.56488 15.4248 7.57986C15.3953 7.64407 15.3665 7.70664 15.3373 7.76899L15.337 7.76974C15.2566 7.94221 15.1777 8.11453 15.0995 8.2856L15.0988 8.28705C14.9481 8.61953 14.7961 8.96149 14.657 9.30927M15.5328 7.19801L14.657 9.30927M14.657 9.30927C14.2392 10.3506 13.8678 11.4021 13.506 12.4471M14.657 9.30927L13.506 12.4471M13.506 12.4471C13.506 12.447 13.506 12.447 13.5061 12.4469L13.9785 12.6107L13.506 12.4471ZM13.506 12.4471C13.3145 12.9995 13.1618 13.5546 13.0249 14.1055L13.506 12.4471ZM12.106 16.9371C12.1139 16.9571 12.1199 16.9699 12.1243 16.9782C12.1244 16.9785 12.1245 16.9787 12.1247 16.979C12.1336 16.9816 12.1498 16.9837 12.1684 16.9787C12.1674 16.979 12.1715 16.978 12.1839 16.9724L12.3428 16.9001L12.5122 16.9424C12.5165 16.9434 12.5197 16.9441 12.5219 16.9446C12.5256 16.944 12.5302 16.9429 12.535 16.941C12.5374 16.94 12.5395 16.939 12.5412 16.938L12.5719 16.8808L12.6214 16.8301C12.6378 16.8134 12.6404 16.7957 12.6376 16.7826L12.6373 16.7813C12.6309 16.7514 12.6278 16.7368 12.6245 16.7217C12.6212 16.7066 12.6178 16.691 12.6109 16.6589L12.5927 16.5734L12.6045 16.4868C12.6109 16.4402 12.6172 16.3936 12.6236 16.347C12.6559 16.1103 12.6885 15.8721 12.7222 15.6342L12.7235 15.6254L12.725 15.6166C12.7352 15.5594 12.7454 15.5018 12.7557 15.4439C12.8327 15.0096 12.9133 14.5549 13.0249 14.1055L12.106 16.9371ZM12.106 16.9371C11.9408 16.5091 11.7699 16.0836 11.6004 15.6614C11.5868 15.6276 11.5733 15.5938 11.5597 15.56L11.556 15.5509L11.552 15.5419C11.4896 15.4025 11.426 15.2621 11.3629 15.1228C11.3239 15.0365 11.285 14.9507 11.2468 14.8659L11.2465 14.8653C11.1705 14.6973 11.0831 14.5274 11.0029 14.3716C10.9736 14.3145 10.9452 14.2593 10.9187 14.2068L12.106 16.9371ZM8.25333 10.2229C8.32651 10.3111 8.39957 10.3989 8.47298 10.4866L8.47479 10.4888L8.47478 10.4888C8.78406 10.8625 9.06427 11.2565 9.33092 11.6315C9.3455 11.652 9.36005 11.6724 9.37456 11.6928L9.37476 11.6931C9.65478 12.0872 9.92853 12.494 10.1825 12.9111L10.1829 12.9117C10.4344 13.3261 10.6912 13.7559 10.9186 14.2067L8.25333 10.2229ZM8.25333 10.2229C8.23283 10.1978 8.21185 10.1726 8.19295 10.15C8.18614 10.1418 8.17959 10.1339 8.17344 10.1265L8.17062 10.1289C7.98145 9.913 7.79077 9.69824 7.59899 9.48471L7.59846 9.48413C7.54918 9.42943 7.5011 9.37667 7.45429 9.3253C7.24339 9.09383 7.05823 8.89061 6.90471 8.66648C6.90586 8.66493 6.90713 8.66337 6.90853 8.66184C6.91276 8.65722 6.91733 8.65367 6.92185 8.65114L6.67778 8.21476M8.25333 10.2229L7.78562 10.4482C7.60082 10.2374 7.41448 10.0276 7.227 9.81882C7.18252 9.76945 7.13762 9.72023 7.09266 9.67095C6.87128 9.4283 6.64854 9.18414 6.46813 8.9134C6.44229 8.87436 6.42388 8.83282 6.41239 8.78993C6.35558 8.5779 6.46715 8.33257 6.67778 8.21476M6.67778 8.21476C6.88311 8.10017 7.17733 8.1148 7.33717 8.27817M6.67778 8.21476L6.92144 8.65137C6.92498 8.6494 6.9333 8.64566 6.9462 8.643C6.95904 8.64034 6.97224 8.63962 6.98376 8.64057C6.98766 8.64088 6.99087 8.64135 6.99341 8.64183M7.33717 8.27817L6.97944 8.62749C6.9841 8.63227 6.98876 8.63705 6.99341 8.64183M7.33717 8.27817C7.65154 8.6001 7.94982 8.93586 8.2477 9.27118C8.2854 9.31362 8.3231 9.35605 8.36082 9.39845L9.88021 12.21C9.57399 11.7497 9.26664 11.3017 8.93544 10.8755L8.9352 10.8752C8.63072 10.4829 8.3167 10.1007 7.98743 9.73098L7.98727 9.7308C7.94933 9.68816 7.91158 9.64566 7.87396 9.60332C7.57967 9.27208 7.29387 8.95039 6.99341 8.64183M7.33717 8.27817L6.97978 8.62784C6.99116 8.63947 6.99999 8.64338 7.00063 8.64365C7.00065 8.64366 7.00065 8.64366 7.00061 8.64365C7.00033 8.64354 6.99795 8.64267 6.99341 8.64183M12.3924 12.5304C12.3882 12.4967 12.384 12.4631 12.3798 12.4294L12.3525 12.5182L12.3924 12.5304ZM15.8998 7.74377L15.8998 7.74376L15.8998 7.74377ZM10.4722 14.432C10.5025 14.4919 10.5332 14.5516 10.5639 14.6113C10.6422 14.7635 10.7205 14.9157 10.791 15.0714C10.8299 15.1578 10.8691 15.2443 10.9082 15.3307C10.9709 15.4691 11.0336 15.6075 11.0957 15.7463C11.1092 15.7799 11.1227 15.8135 11.1362 15.8472L10.4722 14.432Z"
        fill={color ? color : "white"}
        stroke="#F4F3EE"
      />
      <path
        d="M20 16V18C20 19.3 18.6667 19.7917 18 19.875C14.6667 19.875 7.6 19.875 6 19.875C4.4 19.875 4 18.625 4 18V16"
        stroke="#F4F3EE"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DropdownIcon({ color, className }: Props) {
  return (
    <svg
      className={className}
      width="17"
      height="10"
      viewBox="0 0 17 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 0.987305L8.5 8.9873L16.5 0.987305"
        stroke={color ? color : "white"}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SuccessIcon({ color, className }: Props) {
  const svgVariants = {
    hidden: { rotate: -25 },
    visible: { rotate: 0, transition: { duration: 0.5 } },
  };

  return (
    <m.svg
      className={className}
      variants={svgVariants}
      initial="hidden"
      animate="visible"
      width="204"
      height="178"
      viewBox="0 0 204 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_304_12281)">
        <path
          d="M123.525 18.2921C147.053 22.9529 168.763 38.637 179.043 60.7021C183.983 71.871 186.563 83.9339 186.624 96.1398C186.685 108.346 184.224 120.433 179.396 131.651C163.939 167.569 124.1 181.884 87.2673 177.112C44.8307 172.784 1.74461 142.285 0.0560537 96.7867C-0.574039 81.3628 2.64397 66.024 9.42183 52.1443C16.1997 38.2645 26.3257 26.2773 38.8929 17.2563C48.9264 10.0939 60.2947 5.00211 72.33 2.28015C84.3654 -0.44181 96.8251 -0.73909 108.977 1.40573C121.043 3.55415 132.541 8.13598 142.767 14.8704C143.436 15.2849 143.913 15.9474 144.092 16.7123C144.271 17.4771 144.138 18.2815 143.723 18.9486C143.307 19.6157 142.642 20.0909 141.875 20.2695C141.107 20.4481 140.3 20.3157 139.631 19.9012C129.827 14.1667 119.013 10.3559 107.771 8.67442C48.4861 -0.573297 -4.56429 54.1362 11.041 112.693C20.9125 145.781 55.2218 165.479 88.1208 169.511C122.078 174.208 158.762 161.798 173.347 128.95C177.892 118.56 180.281 107.36 180.37 96.0258C180.46 84.6911 178.247 73.4556 173.866 62.9955C164.7 41.5223 144.585 27.6322 123.135 19.3833C123.001 19.3268 122.892 19.2228 122.829 19.0913C122.767 18.9598 122.755 18.8099 122.796 18.6703C122.838 18.5308 122.929 18.4112 123.053 18.3346C123.177 18.258 123.325 18.2297 123.469 18.255L123.525 18.2921Z"
          fill={color ? color : "white"}
        />
        <path
          d="M42.1202 75.7572C52.701 86.7997 61.9717 99.0193 69.7494 112.175C73.4606 117.89 76.8933 124.826 81.458 129.338C82.0147 129.801 82.293 129.727 81.7735 129.69C81.5879 129.69 81.2539 129.801 81.4395 129.69C85.5402 127.415 89.14 123.235 92.5728 119.702C105.784 104.906 118.18 88.9075 131.651 74.1666C152.083 51.7341 175.032 31.7142 200.047 14.5004C200.615 14.1712 201.287 14.0691 201.928 14.2145C202.569 14.3598 203.131 14.7419 203.5 15.2837C203.87 15.8256 204.019 16.4868 203.919 17.1343C203.819 17.7818 203.476 18.3672 202.96 18.7728C187.279 30.9873 172.404 44.1957 158.427 58.316C136.995 79.2528 119.182 103.241 99.6054 126.083C89.3813 137.31 80.5302 147.298 69.4711 130.097C58.8388 113.192 49.6723 95.8248 36.8875 80.4366C36.364 79.7279 36.1247 78.8499 36.2165 77.9746C36.3083 77.0993 36.7246 76.2896 37.3839 75.7041C38.0432 75.1187 38.898 74.7997 39.7809 74.8095C40.6638 74.8193 41.5113 75.1573 42.1573 75.7572H42.1202Z"
          fill={color ? color : "white"}
        />
      </g>
      <defs>
        <clipPath id="clip0_304_12281">
          <rect width="204" height="178" fill="white" />
        </clipPath>
      </defs>
    </m.svg>
  );
}

export function PlayIcon({ color, className, custom }: Props) {
  const svgVariants = {
    hidden: { scale: 0.8 },
    visible: { scale: 1, transition: { duration: 0.5 } },
  };

  if (custom) {
    return (
      <m.div
        variants={svgVariants}
        whileHover={{ scale: 1.05 }}
        initial="hidden"
        animate="visible"
        className={`${className} h-fit w-8 lg:w-12 `}
      >
        <Image
          src={custom?.url}
          width={custom?.width}
          height={custom?.height}
          alt="play"
        />
      </m.div>
    );
  } else {
    return (
      <m.svg
        className={`${className} h-fit w-8 lg:w-12 `}
        variants={svgVariants}
        whileHover={{ scale: 1.05 }}
        initial="hidden"
        animate="visible"
        width="78"
        height="96"
        viewBox="0 0 78 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 7.14423C2 3.19132 6.37046 0.801577 9.69833 2.93483L73.4333 43.7906C76.5022 45.7578 76.5022 50.2422 73.4333 52.2094L9.69832 93.0652C6.37046 95.1984 2 92.8087 2 88.8558V7.14423Z"
          stroke={color ? color : "white"}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </m.svg>
    );
  }
}

export function ClosePop({ color, className }: Props) {
  const svgVariants = {
    hidden: { scale: 0.8 },
    visible: { scale: 1, transition: { duration: 0.5 } },
  };

  return (
    <m.svg
      className={`${className} w-6 h-6 lg:w-12 lg:h-12`}
      variants={svgVariants}
      whileHover={{ scale: 1.05 }}
      initial="hidden"
      animate="visible"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.021 14.9169C16.1664 15.0642 16.2479 15.2631 16.2479 15.4705C16.2479 15.6778 16.1664 15.8768 16.021 16.0241C15.8729 16.1677 15.6751 16.248 15.4692 16.248C15.2633 16.248 15.0655 16.1677 14.9175 16.0241L8.50001 9.57492L2.08252 16.0241C1.93451 16.1677 1.73668 16.248 1.53079 16.248C1.3249 16.248 1.12707 16.1677 0.979059 16.0241C0.833649 15.8768 0.752075 15.6778 0.752075 15.4705C0.752075 15.2631 0.833649 15.0642 0.979059 14.9169L7.40623 8.47739L0.979059 2.03793C0.855578 1.88697 0.792474 1.69531 0.802022 1.50024C0.811569 1.30517 0.893086 1.12063 1.03072 0.982532C1.16835 0.84443 1.35225 0.762634 1.54665 0.753054C1.74106 0.743473 1.93206 0.806793 2.08252 0.930697L8.50001 7.37987L14.9175 0.930697C15.068 0.806793 15.259 0.743473 15.4534 0.753054C15.6478 0.762634 15.8317 0.84443 15.9693 0.982532C16.1069 1.12063 16.1885 1.30517 16.198 1.50024C16.2075 1.69531 16.1444 1.88697 16.021 2.03793L9.59379 8.47739L16.021 14.9169Z"
        fill={typeof color === "string" ? color : color?.hex || "#000"}
      />
    </m.svg>
  );
}

export function Chevron({ color }: Props): JSX.Element {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.47829 0.334123L6.6603 5.65012C6.75131 5.7435 6.80225 5.86873 6.80225 5.99912C6.80225 6.12952 6.75131 6.25475 6.6603 6.34812L1.47829 11.6661C1.4359 11.7097 1.38521 11.7443 1.32922 11.7679C1.27323 11.7915 1.21307 11.8037 1.1523 11.8037C1.09152 11.8037 1.03136 11.7915 0.975372 11.7679C0.919381 11.7443 0.868691 11.7097 0.826295 11.6661C0.739073 11.5768 0.690242 11.457 0.690242 11.3321C0.690242 11.2073 0.739073 11.0874 0.826295 10.9981L5.6993 5.99912L0.826295 1.00112C0.739372 0.911871 0.690731 0.792209 0.690731 0.667623C0.690731 0.543038 0.739372 0.423375 0.826295 0.334123C0.868691 0.29058 0.919381 0.255971 0.975372 0.23234C1.03136 0.208708 1.09152 0.196533 1.1523 0.196533C1.21307 0.196533 1.27323 0.208708 1.32922 0.23234C1.38521 0.255971 1.4359 0.29058 1.47829 0.334123Z"
        fill={color?.hex}
      />
    </svg>
  );
}

export function PauseIcon({ color, className }: Props) {
  const svgVariants = {
    hidden: { scale: 0.8 },
    visible: { scale: 1, transition: { duration: 0.5 } },
  };

  return (
    <m.svg
      variants={svgVariants}
      initial="hidden"
      animate="visible"
      width="43"
      height="41"
      viewBox="0 0 43 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1701_11703)">
        <path
          d="M18 11L18 31"
          stroke={color ? color : "white"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27 11L27 31"
          stroke={color ? color : "white"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1701_11703">
          <rect width="43" height="41" fill={color ? color : "white"} />
        </clipPath>
      </defs>
    </m.svg>
  );
}

interface NutriIconProps {
  color: string;
  type: "vegan" | "vegetarian" | "allergens" | "alcohol" | "energy" | "sugar";
  className: string;
}

export function NutriIcon({
  color,
  type,
  className,
}: NutriIconProps): JSX.Element {
  if (type == "vegan") {
    return (
      <svg
        className={className}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.9986 4L26.4634 4.67931C25.9542 5.3266 14 20.59 14 27.6261C14 34.6394 19.4662 40.3701 26.3146 40.7327V44H27.6826V40.7327C34.5332 40.3701 40 34.6394 40 27.6261C40 20.59 28.043 5.3266 27.5338 4.67931L26.9986 4ZM26.9697 27.983L26.9992 28.0133H26.9409L26.9697 27.983ZM27.682 39.35L27.6826 33.5L31.7741 28.8052L30.8072 27.8274L27.682 30.9861V28.2992L29 26.5197L28.4622 25.5562L26.9692 27.0658L25.5 25.5562L24.4946 26.5197L26.314 28.3575L26.3146 30.5L23.1594 27.8589L22.1926 28.8361L26.314 32.9989V40C20.2204 39.6386 15.3674 33.8761 15.3674 27.6256C16 21.5 24.6473 9.32014 26.9986 6.23464C29.3498 9.32014 38 21.7436 38 27.5C38.0006 33.7511 32.5 38.5 27.682 39.35Z"
          fill={color ? color : "white"}
        />
        <path
          d="M8.94911 10.5992L9.03446 9.90061L9.69307 10.1472C10.0866 10.2948 15.4248 12.1628 20.5409 15.0271L20 16C15.8645 13.6982 12.6468 12.5099 10.9191 11.8311C10.5868 14.9705 9.43286 27.621 11.8608 31.6238C13.3032 34.0019 15.2605 35.3903 17.5 35.798C17.5 36 18.5 36.9696 18.5 36.9696C15.118 36.7746 11.8707 34.9611 9.96892 31.8257C7.00005 26.931 8.86834 11.2645 8.94911 10.5992Z"
          fill={color ? color : "white"}
        />
      </svg>
    );
  } else if (type == "vegetarian") {
    return (
      <svg
        className={className}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23.9986 4L23.4634 4.67931C22.9542 5.3266 11 20.59 11 27.6261C11 34.6394 16.4662 40.3701 23.3146 40.7327V44H24.6826V40.7327C31.5332 40.3701 37 34.6394 37 27.6261C37 20.59 25.043 5.3266 24.5338 4.67931L23.9986 4ZM23.9697 27.983L23.9992 28.0133H23.9409L23.9697 27.983ZM24.682 39.35L24.6826 33.5L28.7741 28.8052L27.8072 27.8274L24.682 30.9861V28.2992L26 26.5197L25.4622 25.5562L23.9692 27.0658L22.5 25.5562L21.4946 26.5197L23.314 28.3575L23.3146 30.5L20.1594 27.8589L19.1926 28.8361L23.314 32.9989V40C17.2204 39.6386 12.3674 33.8761 12.3674 27.6256C13 21.5 21.6473 9.32014 23.9986 6.23464C26.3498 9.32014 35 21.7436 35 27.5C35.0006 33.7511 29.5 38.5 24.682 39.35Z"
          fill={color ? color : "white"}
        />
      </svg>
    );
  } else if (type == "allergens") {
    return (
      <svg
        className={className}
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M36.4363 29.5138C35.8356 29.5138 35.2649 29.6454 34.7514 29.8796C33.7945 30.1262 32.7057 29.0823 32.0275 28.2703C33.1524 26.9474 33.8321 25.2381 33.8321 23.3729C33.8321 21.5083 33.1528 19.7998 32.029 18.4767C32.6861 17.7246 33.6593 16.8509 34.5276 17.011C34.621 17.0466 34.7174 17.0784 34.8145 17.1057C34.8219 17.1093 34.8296 17.1115 34.837 17.1152L34.8326 17.111C35.1172 17.1893 35.4159 17.2319 35.7253 17.2319C37.573 17.2319 39.0767 15.7349 39.0767 13.8951C39.0767 12.0547 37.573 10.5578 35.7253 10.5578C33.8768 10.5578 32.3735 12.0548 32.3735 13.8951C32.3735 14.3343 32.4599 14.7534 32.6156 15.1379C32.7545 16.0033 31.8909 16.951 31.1437 17.5924C29.8117 16.4632 28.088 15.7795 26.2055 15.7795C24.343 15.7795 22.6348 16.4486 21.3091 17.5569C20.3791 16.785 19.0643 15.4624 19.4831 14.4308C19.8372 13.7365 20.038 12.9524 20.038 12.1217C20.038 9.29756 17.7306 7 14.894 7C12.0576 7 9.74988 9.29756 9.74988 12.1217C9.74988 14.9458 12.0576 17.2433 14.894 17.2433C15.7762 17.2433 16.6074 17.0208 17.3338 16.6297C18.3697 16.3102 19.6373 17.5712 20.3852 18.4738C19.2596 19.7973 18.579 21.5071 18.579 23.3729C18.579 25.2154 19.2421 26.9063 20.3425 28.223C19.6427 29.1077 18.2045 30.6854 17.0745 30.3465C16.1781 29.8179 15.1339 29.5139 14.0189 29.5139C10.7 29.5139 8 32.202 8 35.5066C8 38.8115 10.7 41.5 14.0189 41.5C17.3381 41.5 20.0381 38.8115 20.0381 35.5066C20.0381 34.3829 19.7254 33.3312 19.1829 32.4314C18.8549 31.2937 20.4294 29.8834 21.3171 29.1956C22.6417 30.3002 24.3468 30.9666 26.2056 30.9666C28.077 30.9666 29.7919 30.291 31.1202 29.1735C31.9361 29.8561 32.986 30.9508 32.7354 31.8933C32.5039 32.402 32.3736 32.9655 32.3736 33.5595C32.3736 35.7896 34.1966 37.6051 36.4364 37.6051C38.677 37.6051 40.5 35.7896 40.5 33.5595C40.4998 31.3286 38.6768 29.5138 36.4363 29.5138ZM35.7253 11.5C36.7686 11.5 37.6177 12.8556 37.6177 13.8949C37.6177 14.9337 36.7685 15.7793 35.7252 15.7793C34.6812 15.7793 33.8321 14.9337 33.8321 13.8949C33.8321 12.8556 34.6812 11.5 35.7253 11.5ZM11.209 12.1216C11.209 10.0984 12.8622 9 14.894 9C16.926 9 18.579 10.0984 18.579 12.1216C18.579 14.1447 17.032 16.5 15 16.5C12.9682 16.5 11.209 14.1447 11.209 12.1216ZM14.0189 39.5C11.5046 39.5 9.45871 38.0105 9.45871 35.5065C9.45871 33.0033 11.5045 30.9665 14.0188 30.9665C16.5333 30.9665 18.579 33.0033 18.579 35.5065C18.579 38.0104 16.5335 39.5 14.0189 39.5ZM19.4831 23.3729C19.4831 19.9868 22.8048 17.2319 26.2055 17.2319C29.6064 17.2319 32.0275 19.9867 32.0275 23.3728C32.0275 26.7588 29.6064 29.5138 26.2055 29.5138C22.8048 29.5138 19.4831 26.7589 19.4831 23.3729ZM36.4363 36.1516C35.0005 36.1516 33.5 34.9295 33.5 33.5C33.5 31.5 35.0007 30.3465 36.4364 30.3465C37.8729 30.3465 39.0405 32.1295 39.0405 33.5594C39.0405 34.989 37.8728 36.1516 36.4363 36.1516Z"
          fill={color ? color : "white"}
        />
      </svg>
    );
  } else if (type == "alcohol") {
    return (
      <svg
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 19C13 19 13.1798 11 20 11C26.8202 11 27 19 27 19"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
        />
        <path
          d="M17 12C17 12 17.0771 2 20 2C22.923 2 23 12 23 12"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
        />
        <path
          d="M27 19L27 39L13 39L13 19"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
          strokeLinecap="square"
        />
        <path
          d="M13 36H27"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
        />
        <rect
          x="16.65"
          y="19.65"
          width="6.7"
          height="9.7"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
        />
      </svg>
    );
  } else if (type == "energy") {
    return (
      <svg
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 14C7 14 7.17979 6 14 6C20.8202 6 21 14 21 14"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
        />
        <path
          d="M21 14C21 14 21.1798 6 28 6C34.8202 6 35 14 35 14"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
        />
        <path
          d="M35 14C35 23.5 21 34 21 34C21 34 7 23 7 14"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
          strokeLinecap="square"
        />
        <path
          d="M4 21.5H10.5L13.5 15L17.5 24L18.5 21H25.5"
          stroke={color ? color : "white"}
          strokeWidth="1.3"
        />
      </svg>
    );
  } else if (type == "sugar") {
    return (
      <svg
        className={className}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.9907 20.3298V20.269C37.9868 20.2304 37.9784 20.1923 37.9657 20.1556C37.9676 20.1421 37.9676 20.1285 37.9657 20.1151C37.9492 20.064 37.9239 20.0161 37.8908 19.9733C37.8908 19.9733 37.8908 19.9733 37.8908 19.9449C37.8681 19.9161 37.843 19.889 37.8159 19.8639L30.6605 13.6827C30.5768 13.6106 30.475 13.5613 30.3653 13.5399C30.2557 13.5186 30.1422 13.5259 30.0365 13.5612L27.9564 14.2741L26.0178 5.96225V5.9258C26.0197 5.91781 26.0197 5.90948 26.0178 5.90149C26.0178 5.90149 26.0178 5.90149 26.0178 5.88124C26.0051 5.84907 25.9898 5.81792 25.972 5.78808C25.9707 5.77867 25.9707 5.76913 25.972 5.75972C25.9191 5.68367 25.8495 5.62002 25.7682 5.57339H25.7391C25.7074 5.55647 25.6739 5.54289 25.6392 5.53289H25.6184L16.2248 3.02151C16.1193 2.99341 16.0079 2.99283 15.9021 3.01985C15.7962 3.04686 15.6995 3.10052 15.6216 3.17544L8.39962 10.1263C8.37377 10.1542 8.35013 10.184 8.3289 10.2154C8.32042 10.2266 8.31343 10.2389 8.3081 10.2518C8.29071 10.2827 8.27677 10.3153 8.2665 10.3491C8.26473 10.3611 8.26473 10.3734 8.2665 10.3855C8.25381 10.4306 8.24545 10.4767 8.24153 10.5232C8.23946 10.5583 8.23946 10.5935 8.24153 10.6286L9.10684 15.6148C9.1168 15.6494 9.12931 15.6833 9.14428 15.7161L2.2967 20.1718C2.27782 20.1856 2.25977 20.2005 2.24262 20.2163L2.18438 20.2649L2.10534 20.3622C2.08775 20.3821 2.07241 20.4038 2.05958 20.427C2.0474 20.4489 2.03764 20.4719 2.03045 20.4958C2.01896 20.5194 2.00923 20.5438 2.00133 20.5687C2.00133 20.593 2.00133 20.6214 2.00133 20.6457C1.99956 20.6673 1.99956 20.6889 2.00133 20.7105V30.1241C2.00092 30.2401 2.03484 30.3537 2.09903 30.4514C2.16322 30.5491 2.25495 30.6267 2.36327 30.675L11.8193 34.9686L11.9025 34.997H11.9441C11.9897 35.001 12.0357 35.001 12.0813 34.997C12.1449 34.9975 12.2081 34.9879 12.2685 34.9686L12.3268 34.9443L12.4183 34.9038L20.2851 29.1965L25.6059 33.6765C25.647 33.7062 25.6917 33.7307 25.7391 33.7494C25.8231 33.7951 25.9174 33.8202 26.0136 33.8223C26.0551 33.8263 26.0969 33.8263 26.1384 33.8223H26.18C26.2056 33.816 26.2306 33.8079 26.2549 33.798L35.4072 30.0593C35.4952 30.0223 35.5736 29.9668 35.6369 29.8967C35.7002 29.8267 35.7468 29.7439 35.7733 29.6542L37.999 20.4918V20.431C38.0003 20.4216 38.0003 20.4121 37.999 20.4027C37.9983 20.3782 37.9955 20.3538 37.9907 20.3298ZM25.6475 32.1089L20.9258 28.1312L20.6221 19.3414L20.8592 18.5718L27.4822 24.7935L25.6475 32.1089ZM30.103 14.829L36.2559 20.1637L28.3142 23.874L21.7204 17.6888L30.103 14.829ZM20.5971 16.7855L20.0646 14.0432L25.0984 7.51363L26.7625 14.6792L20.5971 16.7855ZM16.2498 4.2853L24.3579 6.45643L19.1619 13.1804L10.0096 10.2883L16.2498 4.2853ZM9.6227 11.4427L18.854 14.3592L19.5446 17.8953C19.5646 17.9949 19.6121 18.0874 19.6819 18.1627L19.6112 18.3976L11.5572 14.5252C11.4585 14.4787 11.349 14.458 11.2396 14.4651C11.1302 14.4722 11.0246 14.5069 10.9331 14.5657L10.2426 15.0154L9.6227 11.4427ZM11.3284 15.7728L18.854 19.39L12.0023 24.8988L10.1802 23.951L3.83179 20.6538L11.3284 15.7728ZM3.24521 21.7232L9.68926 25.0892L11.4532 26.0047V33.4659L3.24521 29.7393V21.7232ZM12.7012 33.1904V25.8993L19.4157 20.5161L19.6777 28.1231L12.7012 33.1904ZM34.6085 29.0386L26.9122 32.1899L28.7302 25.0244L36.4764 21.4113L34.6085 29.0386Z"
          fill={color ? color : "white"}
        />
      </svg>
    );
  } else {
    return <></>;
  }
}

export function VideoPost({}) {
  return (
    <svg
      aria-label="Clip"
      color="#ffffff"
      fill="#ffffff"
      height="18"
      role="img"
      viewBox="0 0 24 24"
      width="18"
    >
      <path
        d="m12.823 1 2.974 5.002h-5.58l-2.65-4.971c.206-.013.419-.022.642-.027L8.55 1Zm2.327 0h.298c3.06 0 4.468.754 5.64 1.887a6.007 6.007 0 0 1 1.596 2.82l.07.295h-4.629L15.15 1Zm-9.667.377L7.95 6.002H1.244a6.01 6.01 0 0 1 3.942-4.53Zm9.735 12.834-4.545-2.624a.909.909 0 0 0-1.356.668l-.008.12v5.248a.91.91 0 0 0 1.255.84l.109-.053 4.545-2.624a.909.909 0 0 0 .1-1.507l-.1-.068-4.545-2.624Zm-14.2-6.209h21.964l.015.36.003.189v6.899c0 3.061-.755 4.469-1.888 5.64-1.151 1.114-2.5 1.856-5.33 1.909l-.334.003H8.551c-3.06 0-4.467-.755-5.64-1.889-1.114-1.15-1.854-2.498-1.908-5.33L1 15.45V8.551l.003-.189Z"
        fillRule="evenodd"
      ></path>
    </svg>
  );
}

export function ZoomInIcon({ color, className }: Props) {
  return (
    <>
      <svg
        width="32"
        className={className}
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 26C20.6274 26 26 20.6274 26 14C26 7.37258 20.6274 2 14 2C7.37258 2 2 7.37258 2 14C2 20.6274 7.37258 26 14 26Z"
          stroke={color?.hex || "black"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23 23L30 30M14 10V18M10 14H18"
          stroke={color?.hex || "black"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function CloseModalIcon({ color, className }: Props) {
  return (
    <>
      <svg
        className={className}
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3726 13.3726L58.6274 58.6274"
          stroke={color?.hex || "black"}
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M58.6274 13.3726L13.3726 58.6274"
          stroke={color?.hex || "black"}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}

export function TimelineIcon({
  className,
  moments,
  color,
}: {
  className: string;
  moments: any;
  color?: string;
}) {
  const totalWidth = 612 - 27; // Subtract the start and end points of the line

  const spacing = totalWidth / (moments.length - 1);
  return (
    <>
      <svg
        className={className}
        width="100%"
        height="64"
        viewBox="0 0 638 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Label of the Points */}
        {moments.map((item: any, index: number) => (
          <text x={12 + index * spacing} y="20" fill="#FAF5F0">
            {item.year}
          </text>
        ))}
        {/* Line of the Timeline */}
        <path d="M27 59H612" stroke="#EDDECD" strokeDasharray="2" />

        {/* Points of the Timeline */}
        {moments.map((item: any, index: number) => (
          <rect
            id={item.year}
            x={27 + index * spacing}
            y="54.5"
            width="9"
            height="9"
            rx="4.5"
            fill={color || "#2D2926"}
            stroke={color || "#EDDECD"}
            strokeDasharray="2 2"
          />
        ))}
      </svg>
    </>
  );
}

